import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import Link from '@mui/material/Link';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Assignment, Edit } from '@mui/icons-material';
import AssessmentScore from 'components/common/AssessmentScore';
import { Link as RouterLink } from 'react-router-dom';
import { Student, StudentAssessment } from 'types';

type Props = {
  student: Student;
  classId: number;
  curriculumId?: number;
  assessmentIds: number[];
  studentAssessments: StudentAssessment[];
  returnTab?: string;
};

const t = (key) => translate('ui', key);

const useStyles = makeStyles((theme: Theme) => {
  return {
    summaryLink: {
      '&.MuiLink-root': {
        color: theme.palette.black.main,
      },
      display: 'flex',
      textDecoration: 'none',
      alignItems: 'center',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    pl2: {
      paddingLeft: theme.spacing(2),
    },
  };
});

const StudentScoreRow = ({
  assessmentIds = [],
  classId,
  curriculumId,
  returnTab = 'Benchmark',
  student,
  studentAssessments = [],
}: Props) => {
  const classes = useStyles();

  return (
    <TableRow>
      <TableCell>
        <Typography variant="body1">{`${student.firstName} ${student.lastName}`}</Typography>
      </TableCell>
      {assessmentIds.map((assessmentId) => {
        const studentAssessment = studentAssessments.find((sa) => sa.assessmentId === assessmentId);

        return (
          <TableCell key={`${student.id}-assessment-${assessmentId}`}>
            <Grid container justifyContent="center" alignContent="center">
              <Link
                underline="none"
                component={RouterLink}
                to={
                  studentAssessment?.stats?.score !== undefined
                    ? `/assessments?assessmentId=${assessmentId}&studentId=${student.id}&classroomId=${classId}&curriculumId=${curriculumId}`
                    : `/assessment/${assessmentId}?studentId=${student.id}&classroomId=${classId}&curriculumId=${curriculumId}`
                }
              >
                {studentAssessment?.stats?.score ? (
                  <AssessmentScore score={studentAssessment.stats.score} />
                ) : (
                  <Edit className={classes.summaryLink} />
                )}
              </Link>
            </Grid>
          </TableCell>
        );
      })}
      {curriculumId && (
        <TableCell>
          <Link
            underline="none"
            className={classes.summaryLink}
            component={RouterLink}
            to={`/studentSummary?studentId=${student.id}&curriculumId=${curriculumId}&classId=${classId}&returnTab=${returnTab}`}
          >
            <Assignment />
            <Typography variant="body1" className={classes.pl2}>
              {t('class.summary')}
            </Typography>
          </Link>
        </TableCell>
      )}
    </TableRow>
  );
};

export default StudentScoreRow;
